let overlayEl: HTMLElement | null = null

export function showSyncOverlay(message: string): void {
  hideSyncOverlay()
  overlayEl = document.createElement('div')
  overlayEl.id = 'device-sync-overlay'
  overlayEl.className = 'device-sync-overlay'
  overlayEl.innerHTML = `
    <div class="device-sync-panel">
      <p class="device-sync-icon" aria-hidden="true">🔄</p>
      <p class="device-sync-title">Sincronizzazione cronologia</p>
      <p class="device-sync-msg" id="device-sync-msg">${escapeHtml(message)}</p>
    </div>
  `
  document.body.appendChild(overlayEl)
  document.body.style.overflow = 'hidden'
}

export function updateSyncOverlay(message: string): void {
  const el = overlayEl?.querySelector('#device-sync-msg')
  if (el) el.textContent = message
}

export function hideSyncOverlay(): void {
  overlayEl?.remove()
  overlayEl = null
  document.body.style.overflow = ''
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
